import { render, staticRenderFns } from "./SalesOrderPreviewMaterialDetails.vue?vue&type=template&id=63151096&scoped=true"
import script from "./SalesOrderPreviewMaterialDetails.vue?vue&type=script&lang=js"
export * from "./SalesOrderPreviewMaterialDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63151096",
  null
  
)

export default component.exports